import * as React from 'react';
import * as _ from 'lodash';
import { AxiosPromise, AxiosResponse } from 'axios';
import { hashHistory } from 'react-router';
import { diagnostics } from 'ui-common';
import { LOGIN_MESSAGE_CODES } from 'login-utils/loginErrorMessageUtils';
import States from 'login-constants/states';

interface ValidateRequestStateProps {
  validate(): AxiosPromise<any>;
  onSuccess?(data: AxiosResponse<any>): void;
}

const requestStateErrors = [
  { error: LOGIN_MESSAGE_CODES.ACTIVATION_INVALID, state: States.LOGIN },
  { error: LOGIN_MESSAGE_CODES.ACTIVATION_EXPIRED, state: States.ACTIVATION_EXPIRED },
  { error: LOGIN_MESSAGE_CODES.ALREADY_ACTIVATED, state: States.LOGIN },
];

class ValidateRequestState extends React.Component<ValidateRequestStateProps, {}> {
  async componentDidMount() {
    const { onSuccess, validate } = this.props;
    try {
      const { data } = await validate();
      if (onSuccess) onSuccess(data);
    } catch (err) {
      const nextState = (() => {
        const errBody = err.response.data;
        const matchedError = _.find(requestStateErrors, { error: errBody }) as any;

        if (!matchedError) {
          diagnostics.breadcrumb(`Redirecting from the request state with an unknown error: ${errBody}`);
          return {
            pathname: States.LOGIN,
            query: { message: LOGIN_MESSAGE_CODES.ACTIVATION_INVALID },
          };
        } else {
          diagnostics.breadcrumb(`Redirecting from the request state because ${errBody}`);

          return {
            pathname: matchedError.state,
            query: { message: errBody },
          };
        }
      })();

      return hashHistory.push(nextState);
    }
  }

  render() {
    const { children } = this.props;
    return React.Children.only(children);
  }
}

export default ValidateRequestState;
